var exports = {
  "wQ": "PollClosedMessage.module__pollResults___ZFNXUl",
  "Gh": "PollClosedMessage.module__resultDescription___ZFNXUl",
  "kq": "PollClosedMessage.module__victorPercentage___ZFNXUl",
};

module.exports = exports;
